import { render, staticRenderFns } from "./modifyName.vue?vue&type=template&id=781b2735&scoped=true&"
import script from "./modifyName.vue?vue&type=script&lang=js&"
export * from "./modifyName.vue?vue&type=script&lang=js&"
import style0 from "./modifyName.vue?vue&type=style&index=0&id=781b2735&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781b2735",
  null
  
)

export default component.exports